import React from 'react';
import { Route, Switch } from "react-router-dom";
import ADCUSecurityList from "./adcu-security-list/adcu-security-list";
import ADCUSecurityDetail from "./adcu-security-detail/adcu-security-detail";

const ADCUSecurities = () => {
  return (
    <Switch>
      <Route exact path="/securities">
        <ADCUSecurityList/>
      </Route>
      <Route exact path="/securities/:securityId">
        <ADCUSecurityDetail/>
      </Route>
    </Switch>
  )
}

export default ADCUSecurities;



